import { CommunityAssociation } from "@entities";
import { MenuItem, Select, TextField } from "@mui/material";
import { type HyperTableFilter } from "@shared/frontend/hyper-table";
import { buildPhoneNumberFieldFilter } from "@shared/helpers/normalize-phone-for-search";

const ACTIVITY_STATUSES = [
  { id: "NEW", label: "חדש" },
  { id: "ACTIVE", label: "פעיל" },
  { id: "INACTIVE", label: "לא פעיל" },
  { id: "LEGACY", label: "מאגר ישן" },
] as const;

export const COMMUNITY_MEMBER_FILTERS: HyperTableFilter<CommunityAssociation>[] = [
  {
    id: "memberSearch",
    icon: "string",
    caption: "שם או טלפון",
    renderFilter: ({ onSave, meta }) => (
      <TextField
        size="small"
        placeholder="שם או טלפון"
        value={(meta.value as string) ?? ""}
        onChange={(event) => {
          const value = event.target.value;
          const query = value.trim();
          const phoneFilter = buildPhoneNumberFieldFilter(query, "partial");
          const clauses = [
            query
              ? {
                  association: {
                    $is: { user: { $is: { name: { $contains: query } } } },
                  },
                }
              : undefined,
            phoneFilter
              ? {
                  association: {
                    $is: { user: { $is: { phoneNumber: phoneFilter } } },
                  },
                }
              : undefined,
          ].filter((clause) => clause != null);
          onSave({
            value: clauses.length
              ? CommunityAssociation.hyperFilter({ $or: clauses })
              : {},
            meta: { value },
          });
        }}
        sx={{ m: 1, minWidth: 180 }}
      />
    ),
  },
  {
    id: "activityStatus",
    icon: "literal",
    caption: "סטטוס פעילות",
    renderFilter: ({ onSave, meta }) => {
      const value = (meta.value as string) ?? "";
      return (
        <Select
          size="small"
          displayEmpty
          value={value}
          onChange={(event) => {
            const next = event.target.value;
            const status = ACTIVITY_STATUSES.find((item) => item.id === next);
            onSave({
              value: status
                ? CommunityAssociation.hyperFilter({
                    association: { $is: { activityStatus: status.id } },
                  })
                : {},
              meta: { value: next, text: status?.label ?? "" },
            });
          }}
          sx={{ m: 1, minWidth: 160 }}
        >
          <MenuItem value="">הכל</MenuItem>
          {ACTIVITY_STATUSES.map((status) => (
            <MenuItem key={status.id} value={status.id}>
              {status.label}
            </MenuItem>
          ))}
        </Select>
      );
    },
  },
];
